// AITeamStrip.jsx — Executive Intelligence Ribbon
// Order: Quinn | Today | The Floor | Research (Selma) | The Studio (Cyrano) | The Market

import React from 'react';
import './AITeamStrip.css';

export default function AITeamStrip({ onNavigate, currentPage }) {
  const isOnFloor    = currentPage === 'floor';
  const isOnToday    = currentPage === 'today';
  const isOnResearch = currentPage === 'research';
  const isOnQuinn    = currentPage === 'quinn';
  const isOnContent  = currentPage === 'content';
  // Victor moved here from the sidebar: it is a SESSION that produces
  // something, not a thing you browse. The Market moved the other way — it is a
  // feed of records, and it was in both places under two names. Morning Plan
  // was alongside Victor until it was retired (IA-7): of its four steps one was
  // unique and moved to Today, one was a stub, and two duplicated Today and
  // Cyrano.
  const isOnVictor   = currentPage === 'victor';

  return (
    <div className="ai-strip">

      {/* Quinn — Executive Assistant */}
      <button
        className={`ai-strip-btn ai-strip-quinn-btn${isOnQuinn ? ' active' : ''}`}
        onClick={() => onNavigate && onNavigate('quinn')}
        title="Quinn — Executive Assistant"
      >
        <span className="ai-strip-icon">👑</span>
        <div className="ai-strip-text">
          <span className="ai-strip-name">Quinn</span>
          <span className="ai-strip-sub">Executive</span>
        </div>
        {isOnQuinn && <span className="ai-strip-active-dot" />}
      </button>

      <div className="ai-strip-divider" />

      {/* Today — Daily Brief */}
      <button
        className={`ai-strip-btn ai-strip-today-btn${isOnToday ? ' active' : ''}`}
        onClick={() => onNavigate && onNavigate('today')}
        title="Today — your daily executive brief"
      >
        <span className="ai-strip-icon">📅</span>
        <div className="ai-strip-text">
          <span className="ai-strip-name">Today</span>
          <span className="ai-strip-sub">Daily Brief</span>
        </div>
        {isOnToday && <span className="ai-strip-active-dot" />}
      </button>

      <div className="ai-strip-divider" />

      {/* The Floor — Primary AI Workspace */}
      <button
        className={`ai-strip-btn ai-strip-floor-btn${isOnFloor ? ' active' : ''}`}
        onClick={() => onNavigate && onNavigate('floor')}
        title="The Floor — your unified AI workspace"
      >
        <span className="ai-strip-icon">⚡</span>
        <div className="ai-strip-text">
          <span className="ai-strip-name">The Floor</span>
          <span className="ai-strip-sub">AI Workspace</span>
        </div>
        {isOnFloor && <span className="ai-strip-active-dot" />}
      </button>

      <div className="ai-strip-divider" />

      {/* Research Studio — Selma */}
      <button
        className={`ai-strip-btn ai-strip-research-btn${isOnResearch ? ' active' : ''}`}
        onClick={() => onNavigate && onNavigate('research')}
        title="Research — Selma's account research engine"
      >
        <span className="ai-strip-icon">🔍</span>
        <div className="ai-strip-text">
          <span className="ai-strip-name">Research</span>
          <span className="ai-strip-sub">Selma</span>
        </div>
        {isOnResearch && <span className="ai-strip-active-dot" />}
      </button>

      <div className="ai-strip-divider" />

      {/* Content Studio — Cyrano */}
      <button
        className={`ai-strip-btn ai-strip-content-btn${isOnContent ? ' active' : ''}`}
        onClick={() => onNavigate && onNavigate('content')}
        title="The Studio — Cyrano's drafting and outreach engine"
      >
        <span className="ai-strip-icon">✍️</span>
        <div className="ai-strip-text">
          <span className="ai-strip-name">The Studio</span>
          <span className="ai-strip-sub">Cyrano</span>
        </div>
        {isOnContent && <span className="ai-strip-active-dot" />}
      </button>

      <div className="ai-strip-divider" />

      {/* Victor — Deal coaching session */}
      <button
        className={`ai-strip-btn ai-strip-victor-btn${isOnVictor ? ' active' : ''}`}
        onClick={() => onNavigate && onNavigate('victor')}
        title="Victor — deal coaching and pursuit strategy"
      >
        <span className="ai-strip-icon">♟️</span>
        <div className="ai-strip-text">
          <span className="ai-strip-name">Victor</span>
          <span className="ai-strip-sub">Strategy</span>
        </div>
        {isOnVictor && <span className="ai-strip-active-dot" />}
      </button>

    </div>
  );
}
